import { Directive, TemplateRef, ViewContainerRef, inject } from "@angular/core";

@Directive({
	selector: "[appShowInDecember]",
	standalone: true,
})
export class ShowInDecemberDirective {
	private templateRef = inject<TemplateRef<any>>(TemplateRef);
	private viewContainer = inject(ViewContainerRef);

	constructor() {
		this.checkDate();
	}

	private checkDate(): void {
		const currentMonth = new Date().getMonth();
		if (currentMonth === 11) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}
}
